export default "__VITE_ASSET__f68b6c0f__"